import { AuthService } from "@/services";

export default {
  methods: {
    async logout() {
      const response = await AuthService.logout();
      if (response) {
        this.$store.dispatch("user/setToken", null);
        this.$store.dispatch("user/setUser", null);
        this.$store.dispatch("user/setBooking", null);
        this.$router.push("/");
      }
    }
  }
};
